import styled from "styled-components";
import { FormControl } from "@mui/material";

export const StyledFormControl = styled(FormControl)`
  min-width: 350px !important;

  @media (max-width: 900px) {
    min-width: 70vw !important;
  }
`;
